module.exports = __webpack_public_path__ + "img/1556896367.45705ed5.jpg";